import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import {
  filetransferjobGet,
  filetransferjobEdit,
  manualJobexec
} from "../../store/actions/filetranfer";

import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import Breadcrumb from "../../components/Breadcrumb";
import {
  Form,
  Button,
  Input,
  Select,
  Switch,
  InputNumber,
  Space,
  message,
  DatePicker,
  Card,
} from "antd";
const { Option } = Select;
const { TextArea } = Input;

class manualJobExcution extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      jobName: [],
      jobid: "",
      dateString: "",
    };
  }
  formRef = React.createRef();
  componentDidMount = async () => {
    try {
      let dataSources = await this.props.filetransferjobGet();
      this.setState({ jobName: dataSources.data.dataArray });
      ////console.log(this.state.jobName);
    }
    catch (e) {
      this.setState({ jobName: [] });

    }


    this.formRef.current.setFieldsValue({
      completeExecution: false,
      fixedValue: null,
      listvalue: null
    });
  };

  //  datepicker
  sorted = async (date, dateString) => {
    //  //console.log("value: ",date);
    //console.log("value: ", dateString);

    this.setState({ dateString: dateString });
  };

  // populate parameter details
  getjobdetails = async (e, val) => {
    try {
      if(val.key !== undefined && val.value === e ){
        let dataSource = await this.props.filetransferjobEdit(val.key);
        this.setState({ jobName: dataSource.data.dataArray, jobid: val.key });
        this.onloadvalues();
      }

    }
    catch (e) {
      let dataSources = await this.props.filetransferjobGet();
      this.setState({ jobName: dataSources.data.dataArray });
      this.defaultload()
    }
  };

  defaultload = () => {
    this.formRef.current.setFieldsValue({
      completeExecution: false,
      jobParameters:[]
    })
  }



  onloadvalues = async () => {
    let jobdata = this.state.jobName;

    var dataArray = [];

    jobdata.forEach((ipsum) => {
      dataArray.push(
        this.formRef.current.setFieldsValue({
          jobParameters: ipsum.jobParameters,
        })

      );
    });
  };

  datapopulate = async (values) => {
    //console.log(values);
    var dataset = [];
    values.jobParameters.map(tag => {
      dataset.push(
        this.state.jobid,
        values.completeExecution,
        tag.name,
        this.state.dateString,
        tag.dateInUtc,
        tag.fixedvalue,
        this.props.api.smData.data.first_name

      )
    })



    //   dataset = [,,name,,values.jobParameters.dateInUtc,values.jobParameters.fixedValue]
    ////console.log(dataset);



    if (await this.props.manualJobexec(dataset)) {
      console.log("sucess")
      this.formRef.current.resetFields();
      let dataSources = await this.props.filetransferjobGet();
      this.setState({ jobName: dataSources.data.dataArray });
    }
    else {
      console.log("Error")

    }

  };

  onFinishFailed = (errorInfo) => {
    //console.log("Failed:", errorInfo);
  };

  render() {

    return (
      <div>
        <div className="container_aa">
          <h3>Manual Job Execution</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "ManualJobExecution",
                breadcrumbName: "Manual Job Execution",
              },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_1_b" style={{ width: "100%" }}>
            <Form
              labelCol={{
                xs: { span: 24 },
                sm: { span: 6 },
                md: { span: 6 },
                lg: { span: 5 },
                xl: { span: 5 },
                xxl: { span: 5 },
              }}
              wrapperCol={{
                xs: { span: 24 },
                sm: { span: 18 },
                md: { span: 18 },
                lg: { span: 15 },
                xl: { span: 12 },
                xxl: { span: 12 },
              }}
              ref={this.formRef}
              onFinish={this.datapopulate}
              onFinishFailed={this.onFinishFailed}
            >
              <Form.Item
                label="Job Name"
                name="jobId"
                rules={[
                  { required: true, message: "Please Input Your Job Name!" },
                ]}
              >
                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  onChange={ (e, val) => {
                     this.getjobdetails(e, val);
                  }}
                  placeholder="Select your Job Name"
                >
                  {this.state.jobName !== null
                    ? this.state.jobName.map((elem, index) => {
                      return (
                        <Option key={elem._id} value={elem._id}>
                          {elem.jobName}
                        </Option>
                      );
                    })
                    : null}
                </Select>
              </Form.Item>

              <Form.Item
                label="Complete Execution"
                name="completeExecution"
                valuePropName="checked"

              >
                <Switch defaultChecked size="large" />
              </Form.Item>

              <Form.Item label="Parameters ">
                <Card title="List of Parameters" style={{ width: "100%" }}>
                  <Form.List name="jobParameters">
                    {(fields, { add, remove }) => (
                      <>

                        {fields.map(({ key, name, fieldKey, ...restField }) => (
                          <Space
                            key={key}
                            style={{ display: "Block", marginBottom: 8 }}
                            align="baseline"
                          >
                            <Form.Item
                              {...restField}
                              label="Name"
                              name={[name, "name"]}
                              fieldKey={[fieldKey, "name"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please Input Parameter Name Field.",
                                },
                              ]}
                            >
                              <Input placeholder="Name" disabled />
                            </Form.Item>

                            <Form.Item
                              {...restField}
                              label="Types"
                              name={[name, "type"]}
                              fieldKey={[fieldKey, "type"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please Input Type.",
                                },
                              ]}
                            >
                              <Select disabled >
                                <Option value="Date">Date</Option>
                                <Option value="Fixed">Fixed</Option>
                                <Option value="List">List</Option>
                                <Option value="Formatted">Formatted</Option>
                              </Select>
                            </Form.Item>

                            <Form.Item noStyle shouldUpdate={() => true}>
                              {({ getFieldValue }) =>
                                getFieldValue([
                                  "jobParameters",
                                  name,
                                  "type",
                                ]) === "Date" ? (
                                  <>
                                    <Form.Item
                                      label="Date"
                                      name={[name, "paramValue"]}
                                      fieldKey={[fieldKey, "date"]}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Please Select Your Execute Date!",
                                        },
                                      ]}
                                    >
                                      <DatePicker
                                        style={{ width: "99%" }}
                                        onChange={this.sorted}
                                      />
                                    </Form.Item>

                                    <Form.Item
                                      label="Date In Utc"
                                      name={[name, "dateInUtc"]}
                                      fieldKey={[fieldKey, "dateInUtc"]}
                                      valuePropName="checked"

                                    >
                                      <Switch defaultChecked />
                                    </Form.Item>
                                  </>
                                ) : getFieldValue([
                                  "jobParameters",
                                  name,
                                  "type",
                                ]) === "Fixed" ? (
                                  <>
                                    <Form.Item
                                      label="Value"
                                      name={[name, "fixedvalue"]}
                                      fieldKey={[fieldKey, "fixedvalue"]}
                                      initialValue={null}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Please Input Your Value !",
                                        },
                                      ]}
                                    >
                                      <Input placeholder="Enter value " />
                                    </Form.Item>
                                  </>
                                ) : getFieldValue([
                                  "jobParameters",
                                  name,
                                  "type",
                                ]) === "List" ? (
                                  <>
                                    <Form.Item
                                      label="Value"
                                      name={[name, "listvalue"]}
                                      fieldKey={[fieldKey, "listvalue"]}
                                      defaultValue={null}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Please Input Your Value !",
                                        },
                                      ]}
                                    >
                                      <TextArea placeholder="Enter value " />
                                    </Form.Item>
                                  </>
                                ) : getFieldValue([
                                  "jobParameters",
                                  name,
                                  "type",
                                ]) === "Formatted" ? (
                                  <>
                                    <Form.Item
                                      label="Format Pattern String"
                                      name={[name, "formatPatternString"]}
                                      defaultValue={null}
                                      fieldKey={[fieldKey, "formatPatternString"]}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Please Input Your Format Pattern String !",
                                        },
                                      ]}
                                    >
                                      <Input placeholder="Enter Format Pattern String" />
                                    </Form.Item>
                                  </>
                                ) : null
                              }
                            </Form.Item>
                          </Space>
                        ))}





                      </>
                    )}
                  </Form.List>
                </Card>
              </Form.Item>







              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    width: "50%",
                    alignItems: "center",
                    "margin-left": "399px",
                  }}
                >
                  Excute
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  filetransferjobGet: () => dispatch(filetransferjobGet()),
  filetransferjobEdit: (id) => dispatch(filetransferjobEdit(id)),
  manualJobexec: (params) => dispatch(manualJobexec(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(manualJobExcution);
